module.exports = __webpack_public_path__ + "static/media/quienes-somos.ea77204d.jpg";